module.exports = __webpack_public_path__ + "static/media/5.dfa2d094.png";